import { render, staticRenderFns } from "./StockPrintTag2.vue?vue&type=template&id=4d775c5c&scoped=true&"
import script from "./StockPrintTag2.vue?vue&type=script&lang=js&"
export * from "./StockPrintTag2.vue?vue&type=script&lang=js&"
import style0 from "./StockPrintTag2.vue?vue&type=style&index=0&id=4d775c5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d775c5c",
  null
  
)

export default component.exports